import { AlertTriangle, CheckCircle, CircleAlert, X } from "lucide-react";

export type FloatingToastTone = "error" | "success" | "warning";
export type FloatingToastState = "visible" | "exiting";

type FloatingToastProps = {
  title: string;
  message?: string;
  tone?: FloatingToastTone;
  state?: FloatingToastState;
  isDesktop?: boolean;
  actionLabel?: string;
  onAction?: () => void;
  onDismiss?: () => void;
};

const iconsByTone = {
  error: AlertTriangle,
  success: CheckCircle,
  warning: CircleAlert,
} satisfies Record<FloatingToastTone, typeof AlertTriangle>;

export function FloatingToast({
  title,
  message,
  tone = "error",
  state = "visible",
  isDesktop = false,
  actionLabel,
  onAction,
  onDismiss,
}: FloatingToastProps) {
  const Icon = iconsByTone[tone];

  return (
    <div
      className="floating-toast"
      role="status"
      aria-live="polite"
      data-tone={tone}
      data-state={state}
      data-desktop={isDesktop ? "true" : undefined}
    >
      <span className="floating-toast-icon" aria-hidden="true">
        <Icon size={16} strokeWidth={2.1} />
      </span>
      <div className="floating-toast-copy">
        <p className="floating-toast-title">{title}</p>
        {message ? <p className="floating-toast-message">{message}</p> : null}
      </div>
      {actionLabel && onAction ? (
        <button
          type="button"
          className="floating-toast-action"
          onClick={onAction}
        >
          {actionLabel}
        </button>
      ) : null}
      {onDismiss ? (
        <button
          type="button"
          className="floating-toast-dismiss"
          aria-label="Fechar mensagem"
          onClick={onDismiss}
        >
          <X size={16} aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}
